import { create } from '@bufbuild/protobuf';

import * as pbm from '@/grpc-gen/message_rule_pb';
import ApiMessageTemplate from '@/model/MessageTemplate';

export enum TemplatePriority {
  LOCALE_MATCH = 0,
  LANGUAGE_MATCH = 1,
  MULTILINGUAL_MATCH = 2,
  DEFAULT_MATCH = 3,
  ACCOUNT_MATCH = 4,
  ENGLISH_MATCH = 5,
  STARRED_MATCH = 10,
  OTHER_MATCH = 20,
  MISSING = -99
}
export default class MessageTemplate {
  id: number = 0;

  messageTypeId?: number;

  layoutId?: number;

  messageDescription?: string;

  locale?: string;

  subject?: string;

  body?: string;

  isDefault: boolean = false;

  isDeleted: boolean = false;

  isExactMatch: boolean = false;

  enabledLocale?: string;

  priority: number = 0;

  rank: number = 0;

  isObsolete: boolean = false;

  get flags(): string {
    const flags: string[] = [];

    if (this.priority === TemplatePriority.MISSING) flags.push('error:missing');

    if (!this.isExactMatch) {
      let fallback = 'fallback:';
      switch (this.priority) {
        case TemplatePriority.LOCALE_MATCH: fallback += 'locale'; break;
        case TemplatePriority.LANGUAGE_MATCH: fallback += 'language'; break;
        case TemplatePriority.MULTILINGUAL_MATCH: fallback += 'multilingual'; break;
        case TemplatePriority.DEFAULT_MATCH: fallback += 'default'; break;
        case TemplatePriority.ACCOUNT_MATCH: fallback += 'account'; break;
        case TemplatePriority.ENGLISH_MATCH: fallback += 'english'; break;
        case TemplatePriority.STARRED_MATCH: fallback += 'star'; break;
        case TemplatePriority.OTHER_MATCH: fallback += 'other'; break;
        default: fallback += 'error'; break;
      }
      flags.push(`locale:${this.locale}`);
      flags.push(fallback);
    }

    return flags.join(', ');
  }

  static fromGrpcModel(o?: pbm.MessageTemplate, opts?: { isObsolete?: boolean }): MessageTemplate {
    const messageTemplate = new MessageTemplate();

    messageTemplate.id = Number(o?.id ?? 0);
    messageTemplate.layoutId = Number(o?.layoutId ?? 0) || undefined;
    messageTemplate.locale = o?.locale || undefined;
    messageTemplate.subject = o?.subject || undefined;
    messageTemplate.body = o?.body || undefined;

    messageTemplate.isDefault = o?.isDefault ?? false;
    messageTemplate.isExactMatch = o?.isExactMatch ?? false;
    messageTemplate.enabledLocale = o?.enabledLocale || undefined;
    messageTemplate.priority = Number(o?.priority ?? 0);
    messageTemplate.rank = Number(o?.rank ?? 0);

    messageTemplate.isObsolete = opts?.isObsolete ?? false;

    return messageTemplate;
  }

  toGrpcModel(): pbm.MessageTemplate {
    return create(pbm.MessageTemplateSchema, {
      id: BigInt(this.id),
      layoutId: BigInt(this.layoutId ?? 0),
      locale: this.locale ?? '',
      subject: this.subject ?? '',
      body: this.body ?? '',
      accountId: 0n,
      campaignId: 0n,
      serviceId: 0n,
      tabId: 0n,
      messageTypeId: 0n,
      eventTypeId: 0n,
    });
  }
}
